export default __webpack_public_path__ + "static/media/gallery_18.ee1c5bdc.jpg";